import { useEffect, useRef } from 'react';

export function BookingWidget() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Check if script already exists
    let script = document.querySelector('script[src="https://asset-tidycal.b-cdn.net/js/embed.js"]') as HTMLScriptElement;
    let isNewScript = false;

    if (!script) {
      // Load TidyCal script if it doesn't exist
      script = document.createElement('script');
      script.src = 'https://asset-tidycal.b-cdn.net/js/embed.js';
      script.async = true;
      isNewScript = true;
      document.body.appendChild(script);
    }

    // Reinitialize TidyCal when script loads or if already loaded
    const initTidyCal = () => {
      if (window.TidyCal && containerRef.current) {
        // TidyCal.init() expects the container element as an argument
        window.TidyCal.init(containerRef.current);
      }
    };

    if (isNewScript) {
      // Wait for the new script to load
      script.addEventListener('load', initTidyCal);
    } else {
      // Script already exists, init immediately
      initTidyCal();
    }

    return () => {
      script.removeEventListener('load', initTidyCal);
    };
  }, []);

  return (
    <div ref={containerRef} className="tidycal-embed" data-path="tillcarlos/project-call"></div>
  );
}
